// extracted by mini-css-extract-plugin
module.exports = {"root":"Notes_root__2jwXN","notes":"Notes_notes__330L_","note":"Notes_note__3fT9J","markdown":"Notes_markdown__vFoZh"};